import { Component } from '@angular/core';

@Component({
  selector: 'app-horizontal-page-header',
  templateUrl: './horizontal-page-header.component.html',
  styleUrls: [],
})
export class HorizontalPageHeaderComponent {
}
